import { render, staticRenderFns } from "./BaseCountdownTimer.vue?vue&type=template&id=90613c24"
import script from "./BaseCountdownTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCountdownTimer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports